.shape-list-container{height:100%;pointer-events:all}
/*# sourceMappingURL=shape-list-and-tag-editor.component.css.map */
